import { IAction } from '@/store/types/action'
import { IState } from './types'
import { GET_MARKETS_INIT,
  GET_MARKETS_SUCCESS,
  GET_MARKETS_ERROR,
  GET_CATEGORIES_INIT,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_FAMILIES_INIT,
  GET_FAMILIES_SUCCESS,
  GET_FAMILIES_ERROR,
  GET_ROOTS_INIT,
  GET_ROOTS_SUCCESS,
  GET_ROOTS_ERROR,
  GET_SECTORS_INIT,
  GET_SECTORS_SUCCESS,
  GET_SECTORS_ERROR,
  GET_SEGMENTS_INIT,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_ERROR,
  GET_SUBMARKETS_INIT,
  GET_SUBMARKETS_SUCCESS,
  GET_SUBMARKETS_ERROR,
  GET_NOMENCLATURES_INIT,
  GET_NOMENCLATURES_SUCCESS,
  GET_NOMENCLATURES_ERROR,
  } from './mutations-types'
import { getApi } from '@/api'
import { dataMarkets } from '@/api/mocks/markets'
import { dataCategories } from '@/api/mocks/categories'
import { dataFamilies } from '@/api/mocks/families'
import config from '../../../../public/config.json'

const getNomenclatures: IAction<IState, any> = async ({ commit }) => {
  commit(GET_NOMENCLATURES_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getNomenclatures()

    commit(GET_NOMENCLATURES_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching nomenclatures', error)
    commit(GET_NOMENCLATURES_ERROR, {error})
  }
}

const getMarkets: IAction<IState, any> = async ({ commit }) => {
  commit(GET_MARKETS_INIT)


  const api = getApi()

  try {
    const response = await api.Nomenclatures.getMarkets()
    commit(GET_MARKETS_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching markets', error)
    commit(GET_MARKETS_ERROR, {error})
  }
}

const getCategories: IAction<IState, any> = async ({ commit }) => {
  commit(GET_CATEGORIES_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getCategories()
    commit(GET_CATEGORIES_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching categories', error)
    commit(GET_CATEGORIES_ERROR, {error})
  }
}

const getFamilies: IAction<IState, any> = async ({ commit }) => {
  commit(GET_FAMILIES_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getFamilies()
    commit(GET_FAMILIES_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching families', error)
    commit(GET_FAMILIES_ERROR, {error})
  }
}

const getRoots: IAction<IState, any> = async ({ commit }) => {
  commit(GET_ROOTS_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getRoots()

    commit(GET_ROOTS_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching roots', error)
    commit(GET_ROOTS_ERROR, {error})
  }
}

const getSectors: IAction<IState, any> = async ({ commit }) => {
  commit(GET_SECTORS_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getSectors()

    commit(GET_SECTORS_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching sectors', error)
    commit(GET_SECTORS_ERROR, {error})
  }
}

const getSubMarkets: IAction<IState, any> = async ({ commit }) => {
  commit(GET_SUBMARKETS_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getSubMarkets()

    commit(GET_SUBMARKETS_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching sub-markets', error)
    commit(GET_SUBMARKETS_ERROR, {error})
  }
}

const getSegments: IAction<IState, any> = async ({ commit }) => {
  commit(GET_SEGMENTS_INIT)

  const api = getApi()

  try {
    const response = await api.Nomenclatures.getSegments()

    commit(GET_SEGMENTS_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching segments', error)
    commit(GET_SEGMENTS_ERROR, {error})
  }
}

export default {
  getMarkets,
  getCategories,
  getFamilies,
  getRoots,
  getSectors,
  getSubMarkets,
  getSegments,
  getNomenclatures,
}
